import { createContext } from "react";

export const FormDataContext = createContext();
